import { render, staticRenderFns } from "./TypeDropdownWrap.vue?vue&type=template&id=561c0a08&scoped=true&"
import script from "./TypeDropdownWrap.vue?vue&type=script&lang=js&"
export * from "./TypeDropdownWrap.vue?vue&type=script&lang=js&"
import style0 from "./TypeDropdownWrap.vue?vue&type=style&index=0&id=561c0a08&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561c0a08",
  null
  
)

export default component.exports